import PracticeMembersAPI from 'api/PracticeMembersAPI'
import UsersAPI from 'api/UsersAPI'
import Store from '@/store'
import PracticesAPI from 'api/PracticesAPI'

export function updateStoreMembers(input) {
    return PracticeMembersAPI.getList(Store.getters['auth/getPractice'].id)
        .then((members) => Store.dispatch('auth/setMembers', members))
        .then(() => input)
        .catch(() => Promise.resolve(input))
}

export function updateCurrentUser() {
    return UsersAPI.getCurrent().then((user) => Store.dispatch('auth/setUser', user))
}

export function updateCurrentPractice() {
    return PracticesAPI.getMy().then((practice) => {
        Store.dispatch('auth/setPractice', practice)
    })
}
